import { render, staticRenderFns } from "./WishTable.vue?vue&type=template&id=320f81ba"
import script from "./WishTable.vue?vue&type=script&lang=js"
export * from "./WishTable.vue?vue&type=script&lang=js"
import style0 from "./WishTable.vue?vue&type=style&index=0&id=320f81ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports